"use strict";

//
// EVDataFile.js
// Javascript implementation of json file handler.
//
export default class EVDatafile {
    constructor(filedata) {
        //    var filedata = JSON.parse( json );
        this.name = filedata["name"];
        this.gender = filedata["gender"];
        this.dataType = filedata["data_type"];
        this.preferredSplineMethod = filedata["spline_method"];
        this.values = filedata["values"];

        this.loaded = true;
    }


//
//
//

    toJSON() {
        const json_object = Object();

        json_object["name"] = this.name;
        json_object["gender"] = this.gender;
        json_object["data_type"] = this.dataType;
        json_object["spline_method"] = this.preferredSplineMethod;
        json_object["values"] = this.values;

        return JSON.stringify(json_object);
    };

//
//
//

    description() {
        let descriptionString = "<br>";
        descriptionString += "EVDataFile<br>";
        descriptionString += "Name: " + this.name + "<br>";
        descriptionString += "Spline method: " + this.preferredSplineMethod + "<br>";
        descriptionString += "<br>";

        return descriptionString;
    };


}
